import { render, staticRenderFns } from "./PreguntasFrecuentes.vue?vue&type=template&id=c5f53c06&scoped=true&"
import script from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts&"
export * from "./PreguntasFrecuentes.vue?vue&type=script&lang=ts&"
import style0 from "./PreguntasFrecuentes.vue?vue&type=style&index=0&id=c5f53c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f53c06",
  null
  
)

export default component.exports